<template>
  <div class="EquipmentDistributionArea">
    <div class="title">
      <span>区域</span>
      <span>部署情况</span>
      <span>使用情况</span>
    </div>
    <div class="row-data">
      <el-scrollbar style="height:100%">
        <div class="row-data-item" v-for="item in lists" :key="item.name">
          <span class="row-val">{{ item.name }}</span>
          <span class="row-val">{{ item.bs }}</span>
          <span class="row-val">{{ item.use }}</span>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EquipmentDistributionArea',
  props: {
    lists: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {}
  },
  computed: {},
  created () {},
  mounted () {},
  watch: {},
  methods: {},
  components: {}
}
</script>

<style scoped lang="stylus">
.EquipmentDistributionArea
  .title
    display flex
    font-size: .9rem
    color: #fff
    margin-bottom .6rem
    span
      flex-shrink: 0
      flex-basis: 33%
      text-align center
  .row-data-item
    display flex
    font-size: 0.8rem;
    font-family: NotoSansHans-Regular, NotoSansHans;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.6);
    margin-bottom: .4rem
    .row-val
      flex-shrink: 0
      flex-basis: 33%
      text-align center
      display inline-block
      height: 1rem
      line-height: 1rem
.row-data
  height 11.3rem
  overflow: hidden
  >>> .el-scrollbar__wrap
        overflow-x: hidden
</style>
